import { render, staticRenderFns } from "./DeviceButton.vue?vue&type=template&id=55c21144&scoped=true"
import script from "./DeviceButton.vue?vue&type=script&lang=js"
export * from "./DeviceButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c21144",
  null
  
)

export default component.exports